import React, { Component } from 'react'
import classNames from 'classnames'

import { IconButton } from '../Icon'
import './CheckboxRow.css'

export default class CheckboxRow extends Component {
  handleClick = () => {
    const { input } = this.props
    const { value, onChange } = input

    onChange(!value)
  }

  render() {
    const { input, label, meta, ...props } = this.props
    const icon = input.value ? 'checkbox' : 'checkbox-empty'
    const { touched, error } = meta

    return (
      <div
        className={classNames(
          'checkbox-row',
          touched && error && 'checkbox-row-error'
        )}
      >
        <div className="checkbox-row-checkbox-wrapper">
          <IconButton {...props} large type={icon} onClick={this.handleClick} />
        </div>
        <p className="checkbox-row-label">{label}</p>
        {touched && error ? (
          <div className="wrapped-input-error-message">{error}</div>
        ) : null}
      </div>
    )
  }
}
